"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPdfElementsOutputDtoSchema = exports.renderPdfElementsInputDtoSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = __importStar(require("zod"));
const uniqueElementIndexesSchema = z
    .array(z.number().int().min(0))
    .min(1)
    .max(20)
    .refine((indexes) => new Set(indexes).size === indexes.length, {
    message: 'elementIndexes must be unique',
});
const uniquePageNumbersSchema = z
    .array(z.number().int().min(1))
    .min(1)
    .max(5)
    .refine((pageNumbers) => new Set(pageNumbers).size === pageNumbers.length, {
    message: 'pageNumbers must be unique',
});
exports.renderPdfElementsInputDtoSchema = z
    .object({
    fileId: z.string().min(1),
    elementIndexes: uniqueElementIndexesSchema.optional(),
    pageNumbers: uniquePageNumbersSchema.optional(),
    citedText: z.string().trim().min(1).max(4000).optional(),
    renderMode: z.enum(['page', 'crop']),
    includeImage: z.boolean().optional().default(true),
})
    .superRefine(({ elementIndexes, pageNumbers, citedText, renderMode }, context) => {
    const hasElements = (elementIndexes?.length ?? 0) > 0;
    const hasPages = (pageNumbers?.length ?? 0) > 0;
    const hasCitedText = citedText !== undefined;
    if (!hasElements && !hasPages && !hasCitedText) {
        context.addIssue({
            code: 'custom',
            message: 'At least one element index, page number, or cited text is required',
        });
    }
    if (renderMode === 'crop' && ((!hasElements && !hasCitedText) || (hasPages && !hasCitedText))) {
        context.addIssue({
            code: 'custom',
            message: 'Crop mode requires elementIndexes or citedText; pageNumbers require citedText',
        });
    }
});
const renderedPdfElementSchema = z.object({
    elementIndex: z.number().int().min(0),
    elementType: sigma_engine_shared_1.PdfElementTypeSchema,
    text: z.string().nullable(),
    boundingBox: sigma_engine_shared_1.boundingBoxSchema,
});
const renderedPdfPageSchema = z.object({
    pageNumber: z.number().int().min(1),
    elementIndexes: z.array(z.number().int().min(0)),
    elements: z.array(renderedPdfElementSchema),
    renderedRegion: sigma_engine_shared_1.boundingBoxSchema.nullable(),
    base64Image: z.string().nullable(),
});
exports.renderPdfElementsOutputDtoSchema = z.object({
    fileId: z.string(),
    renders: z.array(renderedPdfPageSchema).max(5),
});
//# sourceMappingURL=render-pdf-elements.dto.js.map